import React, { useContext, useEffect } from 'react';
import classNames from 'classnames/bind';
import proptypes from 'prop-types';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { Fieldset } from '@thd-olt-component-react/fieldset';
import { RequestAQuoteCta } from '@thd-olt-component-react/home-services-cta-buttons';
import { DUAL_PATH_CATEGORIES, MOBILE } from '@thd-olt-functional/utils';

import { InfoBoxLink } from '../common/info-box-link/InfoBoxLink';
import { InfoPodsContainer } from '../common/info-pods-container/InfoPodsContainer';
import { dataModel } from './dataModel';
import * as collectionPodStyles from './collection.scss';
import {
  buildServiceReviewsUrl,
  leftPodDetails,
  leftPodTitle,
  rightPodDetails,
  rightPodTitle
} from './collection-constants';

const { string } = proptypes;

const cx = classNames.bind(collectionPodStyles);

const CollectionPod = ({ itemId, storeId: storeIdProp }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('home-services.ready'); }, []);

  const { storeId } = useStore();
  const { channel } = useContext(ExperienceContext);

  const isMobile = channel === MOBILE;

  const options = {
    variables: {
      itemId,
      storeId: storeIdProp || storeId
    },
    ssr: false,
    skip: storeId === '8119'
  };

  const { data, loading } = useDataModel('serviceAddOns', options);

  if (!itemId || loading || !data?.serviceAddOns?.sellFurnishInstall?.dualPathSku) {
    return null;
  }
  const installationProgramCategory = data?.serviceAddOns?.sellFurnishInstall?.installationProgramCategory;
  const displayDualPathLead = [
    DUAL_PATH_CATEGORIES.TANKLESS_WATER_HEATER,
    DUAL_PATH_CATEGORIES.TANK_WATER_HEATER
  ].includes(installationProgramCategory);

  if (!displayDualPathLead) {
    return null;
  }

  const serviceReviewsUrl = installationProgramCategory && buildServiceReviewsUrl(installationProgramCategory);

  return (
    <section className={cx('collection-pod')} data-component="CollectionPod">
      <Fieldset
        title="Installed by Home Services"
        iconUrl="https://assets.homedepot-static.com/images/v1/use-and-care-manual.svg"
        border={!isMobile}
      >
        <div className="collection-pod__container">
          <section className="collection-pod__title">
            Get <strong className="u__text--success collection-pod--highlight">FREE</strong>
            installation help and recommendations from one of our experts
          </section>
          <RequestAQuoteCta
            itemId={itemId}
          />
          <InfoPodsContainer
            leftPodTitle={leftPodTitle}
            leftPodDetails={leftPodDetails}
            rightPodTitle={rightPodTitle}
            rightPodDetails={rightPodDetails}
          />
          <InfoBoxLink
            title="Service Reviews"
            href={serviceReviewsUrl}
          />
        </div>
      </Fieldset>
    </section>
  );
};

CollectionPod.displayName = 'CollectionPod';

CollectionPod.propTypes = {
  itemId: string.isRequired,
  storeId: string
};

CollectionPod.defaultProps = {
  storeId: null
};

CollectionPod.dataModel = extend(dataModel, RequestAQuoteCta);

export { CollectionPod };
